const menuItems = [
  {
    icon: 'home',
    path: '/',
    title: 'Início'
  },
  {
    icon: 'people',
    path: '/registro/estudantes',
    title: 'Estudantes'
  },
  {
    icon: 'restaurant',
    path: '/refeicoes/estudantes',
    title: 'Controle de Refeições'
  }
]

export default menuItems
